import './ResumenTitle.css'
const ResumenTitle = ({ children }: { children: string }) => {
    return (
        <p className='shared-resumen__title'>{children}</p>
    )
}

export default ResumenTitle